import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// ============================================================================
// pwa-links-client-mod -- 编辑器弹窗
//
// 新建/编辑 PWA 链接的表单弹窗。
// ============================================================================
import * as React from 'react';
export function PwaLinksEditorDialog({ link, categories, onSave, onClose }) {
    const [form, setForm] = React.useState({
        name: link?.name ?? '',
        url: link?.url ?? '',
        description: link?.description ?? '',
        icon: link?.icon ?? '',
        category: link?.category ?? '',
        tags: link?.tags?.join(', ') ?? '',
        order: link?.order ?? 100,
    });
    const [saving, setSaving] = React.useState(false);
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!form.name || !form.url)
            return;
        setSaving(true);
        try {
            await onSave(form);
        }
        finally {
            setSaving(false);
        }
    };
    const inputStyle = {
        width: '100%',
        padding: '8px 12px',
        borderRadius: 8,
        border: '1px solid #d1d5db',
        fontSize: 14,
        outline: 'none',
        boxSizing: 'border-box',
    };
    const labelStyle = {
        display: 'block',
        marginBottom: 4,
        fontSize: 13,
        fontWeight: 500,
        color: '#374151',
    };
    return (_jsx("div", { style: overlayStyle, onClick: onClose, children: _jsxs("div", { style: dialogStyle, onClick: (e) => e.stopPropagation(), children: [_jsx("h3", { style: { margin: '0 0 20px', fontSize: 16, fontWeight: 600, color: '#111827' }, children: link ? '编辑应用' : '新增应用' }), _jsxs("form", { onSubmit: handleSubmit, children: [_jsxs("div", { style: { display: 'flex', flexDirection: 'column', gap: 14 }, children: [_jsxs("div", { children: [_jsx("label", { style: labelStyle, children: "\u540D\u79F0 *" }), _jsx("input", { type: "text", value: form.name, onChange: (e) => setForm(f => ({ ...f, name: e.target.value })), placeholder: "\u5E94\u7528\u540D\u79F0", required: true, style: inputStyle })] }), _jsxs("div", { children: [_jsx("label", { style: labelStyle, children: "URL *" }), _jsx("input", { type: "url", value: form.url, onChange: (e) => setForm(f => ({ ...f, url: e.target.value })), placeholder: "https://example.com", required: true, style: inputStyle })] }), _jsxs("div", { children: [_jsx("label", { style: labelStyle, children: "\u63CF\u8FF0" }), _jsx("textarea", { value: form.description, onChange: (e) => setForm(f => ({ ...f, description: e.target.value })), placeholder: "\u5E94\u7528\u7684\u7B80\u77ED\u63CF\u8FF0", rows: 2, style: { ...inputStyle, resize: 'vertical' } })] }), _jsxs("div", { children: [_jsx("label", { style: labelStyle, children: "\u56FE\u6807 URL" }), _jsx("input", { type: "url", value: form.icon, onChange: (e) => setForm(f => ({ ...f, icon: e.target.value })), placeholder: "https://example.com/icon.png", style: inputStyle })] }), _jsxs("div", { style: { display: 'flex', gap: 12 }, children: [_jsxs("div", { style: { flex: 1 }, children: [_jsx("label", { style: labelStyle, children: "\u5206\u7C7B" }), categories.length > 0 ? (_jsxs("select", { value: form.category, onChange: (e) => setForm(f => ({ ...f, category: e.target.value })), style: inputStyle, children: [_jsx("option", { value: "", children: "\u65E0\u5206\u7C7B" }), categories.map(cat => (_jsx("option", { value: cat.slug, children: cat.name }, cat.slug)))] })) : (_jsx("input", { type: "text", value: form.category, onChange: (e) => setForm(f => ({ ...f, category: e.target.value })), placeholder: "\u8F93\u5165\u5206\u7C7B", style: inputStyle }))] }), _jsxs("div", { style: { width: 100 }, children: [_jsx("label", { style: labelStyle, children: "\u6392\u5E8F" }), _jsx("input", { type: "number", value: form.order, onChange: (e) => setForm(f => ({ ...f, order: parseInt(e.target.value, 10) || 0 })), style: inputStyle })] })] }), _jsxs("div", { children: [_jsx("label", { style: labelStyle, children: "\u6807\u7B7E\uFF08\u9017\u53F7\u5206\u9694\uFF09" }), _jsx("input", { type: "text", value: form.tags, onChange: (e) => setForm(f => ({ ...f, tags: e.target.value })), placeholder: "\u6548\u7387, \u5DE5\u5177, AI", style: inputStyle })] })] }), _jsxs("div", { style: { display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 24 }, children: [_jsx("button", { type: "button", onClick: onClose, style: {
                                        padding: '8px 16px',
                                        borderRadius: 8,
                                        border: '1px solid #d1d5db',
                                        backgroundColor: '#fff',
                                        fontSize: 13,
                                        color: '#4b5563',
                                        cursor: 'pointer',
                                    }, children: "\u53D6\u6D88" }), _jsx("button", { type: "submit", disabled: saving || !form.name || !form.url, style: {
                                        padding: '8px 16px',
                                        borderRadius: 8,
                                        border: 'none',
                                        backgroundColor: (!form.name || !form.url || saving) ? '#d1d5db' : '#4f46e5',
                                        color: '#fff',
                                        fontSize: 13,
                                        fontWeight: 500,
                                        cursor: (!form.name || !form.url || saving) ? 'not-allowed' : 'pointer',
                                    }, children: saving ? '保存中...' : '保存' })] })] })] }) }));
}
const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
};
const dialogStyle = {
    width: '100%',
    maxWidth: 480,
    backgroundColor: '#fff',
    borderRadius: 16,
    padding: 24,
    boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
    maxHeight: '90vh',
    overflow: 'auto',
};
//# sourceMappingURL=pwa-links-editor-dialog.js.map